export default {
  "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["hello i18n !!"])},
  "copyright": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["© 2021-2024 PanopticAI Ltd. All Rights Reserved."])}
}